<template>
    <div>
        <div class="radioGroup">
            <div class="row">
                <div class="col-lg-6">
                    <div v-for="(type, key) in calculation_types" class="custom-control custom-radio custom-control-inline">
                        <input type="radio" :id="'customRadioInline' + key"
                               v-model="form.payment_calculation_type"
                               name="customRadioInline" class="custom-control-input"
                               :value="parseInt(key)"
                        >
                        <label class="custom-control-label" :for="'customRadioInline' + key">{{type}}</label>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group form-row" v-if="form.payment_calculation_type === 1">
                        <label class="col-sm-3 col-form-label fs-12 pt-12">Тариф:</label>
                        <div class="col-sm-9">
                            <select-picker :form="form"
                                           :field="'tariff_id'"
                                           :items="tariffs"
                                           :value="'id'"
                                           :text="'name'"
                                           :prompt="i18n('Choose a rate')">
                            </select-picker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-wrapper" v-if="stations.length" style="height: auto">
            <div class="table-responsive">
                <table class="table inputPrice">
                    <thead>
                    <tr>
                        <th scope="col" nowrap=""></th>
                        <th scope="col" v-for="(station, i) in stations" v-if="i > 0" :class="{'bg-primary': y === i}">
                            {{station.station ? station.station.name : null}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(station, i) in stations" v-if="i < stations.length - 1">
                        <td :class="{'bg-primary': x === i}">
                            {{station.station ? station.station.name : null}}
                        </td>
                        <td v-for="(stat, j) in stations" v-if="j > 0" :class="{'bg-darker': x >= i && y === j || x === i && y >= j}">
                            <input v-if="j > i" @focus="x=i; y=j"
                                   type="text" class="form-control"
                                   v-model="prices[i][j]" @change="roundPrice(i, j)"
                                   :disabled="form.payment_calculation_type === 1">
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import SelectPicker from '../../../components/SelectPicker';

    export default {
        name: "SetPrices",
        components: {SelectPicker},
        props: {
            form: {
                type: Object,
                required: true
            },
            stations: {
                type: Array,
                default: []
            },
            prices: {
                type: Array,
                default: []
            },
            tariffs: {
                type: Array,
                default: []
            },
            isUpdate: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                calculation_types: [],
                x: null,
                y: null,
            }
        },
        created() {
            this.getCalculationTypes();
        },
        methods: {
            getCalculationTypes() {
                this.$api.get('schedule-trips.calculation')
                    .then(res => {
                        this.calculation_types = res.data;
                    });
            },
            roundAllPrices() {
                for (let i = 0; i < this.stations.length; i++) {
                    for (let j = i + 1; j < this.stations.length; j++) {
                        this.roundPrice(i, j);
                    }
                }
            },
            roundPrice(i, j) {
                this.prices[i][j] = Math.ceil(this.prices[i][j] / 500) * 500;
                this.fillPreviousPrices(i, j);
                this.$forceUpdate();
            },
            fillPreviousPrices(i, j) {
                for (let k = 0; k < j; k++) {
                    if (this.prices[i][k] === 0) {
                        this.prices[i][k] = this.prices[i][j];
                    }
                }
            }
        },
        watch: {
            isUpdate: function (val) {
                if (val === true) {
                    // console.log(this.stations);
                }
            },
            "form.tariff_id": function () {
                this.$emit('tariffChanged');
                this.roundAllPrices();
                this.$forceUpdate();
            },
            stations: function () {
                this.roundAllPrices();
            }
        }
    }
</script>

<style scoped>
    .bg-darker {
        background-color: #e4e8eb;
    }
</style>
